import { render, staticRenderFns } from "./CorrectTextMatchPicker.vue?vue&type=template&id=7628ef4e&scoped=true&"
import script from "./CorrectTextMatchPicker.vue?vue&type=script&lang=ts&"
export * from "./CorrectTextMatchPicker.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectTextMatchPicker.vue?vue&type=style&index=0&id=7628ef4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628ef4e",
  null
  
)

export default component.exports